export default __webpack_public_path__ + "static/media/support_page_support_icon.3da1f95a.svg";